import request from "../shared/http";

class ApiKeysService {
  static async list() {
    const { data } = await request.get("/api-keys");
    return data;
  }

  static async create(name) {
    const { data } = await request.post("/api-keys", { name });
    return data;
  }

  static async revoke(id) {
    const { data } = await request.delete(`/api-keys/${id}`);
    return data;
  }
}

export default ApiKeysService;
